/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

// One loader per route; shared by lazy() and prefetchRoute.
export const load = {
  '/': () => import('@/features/home/HomePage'),
  '/schematic-explorer': () => import('./pages/ExplorerPage'),
  '/mecl': () => import('./pages/MeclPage'),
  '/schematics': () => import('./pages/SchematicsPage'),
  '/viewer-3d': () => import('./pages/Viewer3DPage'),
  '/resource-links': () => import('./pages/ResourceLinksPage'),
  '/analytics': () => import('./pages/AnalyticsPage'),
  '/admin': () => import('./pages/AdminPage'),
  '*': () => import('./pages/NotFoundPage'),
} as const;

/** Prefetch a route chunk on hover/focus; errors are swallowed. */
export function prefetchRoute(path: string): void {
  const loader = load[path as keyof typeof load];
  if (loader) loader().catch(() => {});
}
